import { createContext, useContext, type ReactNode } from "react"

import {
  useHumanFeedbackUpdate,
  type UseHumanFeedbackUpdateProps,
  type UseHumanFeedbackUpdateReturn,
} from "../hooks/useHumanFeedbackUpdate"

const HumanFeedbackUpdateContext =
  createContext<UseHumanFeedbackUpdateReturn | null>(null)

export const HumanFeedbackUpdateProvider: React.FC<
  UseHumanFeedbackUpdateProps & { children: ReactNode }
> = ({ children, ...props }) => {
  const controller = useHumanFeedbackUpdate(props)

  return (
    <HumanFeedbackUpdateContext.Provider value={controller}>
      {children}
    </HumanFeedbackUpdateContext.Provider>
  )
}

export const useSharedHumanFeedbackUpdate = () =>
  useContext(HumanFeedbackUpdateContext)
